import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SubjectService {
    cancelSubject = new Subject<boolean>();
    leaveSubject = new Subject<boolean>();
    refreshTrigger$ = new Subject();
}